export default __webpack_public_path__ + "static/media/spark_26.2d7e1655.png";